import { Picture } from "@/components/media/Picture";
import { siteConfig } from "@/config/site";

export function HomeFounder() {
  const city = siteConfig.contact.address.city;
  const state = siteConfig.contact.address.state;

  return (
    <section className="container-page py-16 md:py-24">
      <div className="grid gap-12 md:grid-cols-[280px_1fr] items-start">
        <div className="mx-auto md:mx-0">
          <div className="relative">
            <div
              aria-hidden
              className="absolute -inset-4 rounded-2xl"
              style={{ background: "var(--gradient-primary)", opacity: 0.15, filter: "blur(24px)" }}
            />
            <Picture
              variantKey="umair"
              alt={`${siteConfig.founder.name} — Founder of ${siteConfig.name}, ${city} SEO agency`}
              width={280}
              height={340}
              sizes="280px"
              className="relative block shrink-0"
              imgClassName="rounded-2xl object-cover w-[280px] h-[340px]"
            />
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-primary">Founder · {city}, {state}</div>
          <h2 className="mt-3 font-display text-4xl md:text-5xl leading-tight">
            {city} SEO you can trace to a strategy — not a vendor promise.
          </h2>
          <p className="mt-6 text-muted-foreground leading-relaxed">
            I'm {siteConfig.founder.name}, founder of {siteConfig.name}. I started this {city} SEO agency

            because most agencies in Central Texas — and everywhere else — sell rankings without
            accountability. We do the opposite: every engagement ships a dated roadmap, weekly
            reviews, monthly executive-grade reports, and a metric baseline you can benchmark
            against forever. I've spent a decade running SEO for automotive, HVAC, security,
            SaaS and professional-services brands, and I lead strategy on every {siteConfig.name}
            account personally.
          </p>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            The four {city} and Central Texas case studies on this site are real. Semrush and
            Google Search Console screenshots. Named clients — Foreign Affairs Auto, Lynx
            Systems, Air Tech Pro HVAC, Carage Auto. Dated performance windows. That's the
            E-E-A-T standard we hold ourselves to on every new engagement, and it's the
            standard the AI Overviews and ChatGPT reward.
          </p>
          <blockquote className="mt-8 border-l-2 border-primary pl-4 italic text-foreground/90">
            "Rankings are a lagging indicator. What {siteConfig.name} sells is the compounding
            local growth system behind them — the one {city}'s best operators can audit any
            Monday morning."
          </blockquote>
        </div>
      </div>
    </section>
  );
}
